import React, { useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { EPAPER_BANNER_TEXT } from "../../../constants";
import "./new-body-banner.m.css";

const EPAPER_BASE_URL = "https://epaper.prajavani.net";

const buildEpaperUrl = (utmMedium) => {
  // ✅ Guaranteed order:
  // utm_source → utm_medium → utm_campaign
  return `${EPAPER_BASE_URL}?utm_source=pvsite&utm_medium=${utmMedium}&utm_campaign=awareness`;
};

// Helper function to strip anchor tags from HTML while preserving inner content
const stripAnchorTags = (html) => {
  if (!html) return html;
  // Remove opening <a> tags with any attributes
  let cleaned = html.replace(/<a\s[^>]*>/gi, '');
  // Remove closing </a> tags
  cleaned = cleaned.replace(/<\/a>/gi, '');
  return cleaned;
};

const NewBodyWidget = () => {
  const [imageError, setImageError] = useState(false);

  const epaperUrl = buildEpaperUrl("inarticle");

  // CMS HTML (may contain its own <a>, but we strip them to ensure our URL is used)
  const cmsContent = useSelector((state) =>
    get(
      state,
      ["qt", "config", "publisher-attributes", "epaper-banner-content"],
      null
    )
  );

  // 🔹 If CMS content exists, strip any anchor tags and wrap it with our URL
  if (cmsContent) {
    const cleanedContent = stripAnchorTags(cmsContent);
    return (
      <a
        href={epaperUrl}
        target="_blank"
        rel="noopener noreferrer"
        styleName="banner-wrapper"
        dangerouslySetInnerHTML={{ __html: cleanedContent }}
      />
    );
  }

  // 🔹 Default React banner
  return (
    <a
      href={epaperUrl}
      target="_blank"
      rel="noopener noreferrer"
      styleName="banner-wrapper"
    >
      <div styleName="banner-left">
        <div styleName="banner-title">
          {EPAPER_BANNER_TEXT.HEADLINE}
        </div>
        <div styleName="banner-subtitle">
          {EPAPER_BANNER_TEXT.SUBHEADLINE}
        </div>
      </div>

      <div styleName="banner-center">
        <div styleName="divider" />
        {!imageError && (
          <img
            src="/images/smartphone.png"
            alt="ePaper on Smartphone"
            styleName="banner-image"
            loading="eager"
            onError={() => setImageError(true)}
          />
        )}
      </div>

      <span styleName="banner-btn">
        <span styleName="mob-button-text">
          {EPAPER_BANNER_TEXT.BUTTON_MOBILE}
        </span>
        <span styleName="dsk-button-text">
          {EPAPER_BANNER_TEXT.BUTTON_DESKTOP}
        </span>
      </span>
    </a>
  );
};

export default NewBodyWidget;
